import { action, observable } from 'mobx'

import Ds from './ds'

class Hardware {
  @observable data = []

  @observable ds = new Ds()

  @action loadAllHardware() {
    this.ds.query(`{ hardware(hash: "${ localStorage.getItem('userHash') }") { id name description baseCost } }`, (data) => {
      this.data = data.hardware
    })
  }

  @action newHardware(row) {
    this.ds.query(`mutation { addHardware(name: "${ row.name }", description: "${ row.description }", baseCost: ${ row.baseCost }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllHardware()
    })
  }

  @action updateHardware(row) {
    this.ds.query(`mutation { updateHardware(id: ${ row.id }, name: "${ row.name }", description: "${ row.description }", baseCost: ${ row.baseCost }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllHardware()
    })
  }

  @action deleteHardware(id) {
    this.ds.query(`mutation { deleteHardware(id: ${ id }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllHardware()
    })
  }
}

export default new Hardware()



// WEBPACK FOOTER //
// ./src/stores/hardware.js